import React from 'react';

import useForm from './useForm';

import imgUrl from '../images/bg.png';
import middle from '../images/middle.png';

import { Wrap, FormWrap, Box, CheckWrap, Label, Radio, InputWrap, Button, BtnWrap } from './styled'; 

function ProFormComponent() {
  const { state, isSending, changeState, submit } = useForm();

  return (
    <Wrap imgUrl={imgUrl}>
      <img src={middle} alt="" />

      <FormWrap>
        <p className="title">이벤트 신청</p>

        <Box>
          <p className="title">개인정보 이용 및 처리</p>

          <ul>
            <li>
              <span className="idx">1.</span> <span className="title">개인정보 수집, 이용 목적</span> : 당첨자 본인 확인 및 이벤트 경품 발송
            </li>

            <li>
              <span className="idx">2.</span> <span className="title">수집하는 개인정보 항목</span> : 다방프로 ID, 이름, 연락처 
            </li>

            <li>
              <span className="idx">3.</span> <span className="title">개인정보 보유 및 이용 기간</span> : 이벤트 종료후 60일 까지 
            </li>

            <li>
              <span className="idx">4.</span> <span className="title">동의 및 철회방법</span> : 다방 대표번호를 통해 철회를 요청하시면 15일 이내 개인정보 열람을 할 수 없도록 삭제 및 파기됩니다.
            </li>

            <li>
              <span className="idx">5.</span> <span className="title">개인정보 수집, 이용 목적</span> : 개인정보 이용 및 처리에 대한 동의를 하지 않으실 경우, 부득이하게 이벤트 당첨 사실이 취소됨을 알려드립니다. 
            </li>
          </ul>

          <CheckWrap>
            <Label>
              동의
              <Radio name="agree" value={true} onChange={changeState} />
            </Label>

            <Label>
              거부
              <Radio name="agree" value={false} onChange={changeState} />
            </Label>
          </CheckWrap>

          <InputWrap>
            <p className="title">회원ID</p>
            <div className="text-field">
              <input type="text" name="email" value={state.email} onChange={changeState} />
              <p className="black">다방 프로 회원 아이디를 입력해주세요</p>
              <p className="red">*잘못된 정보 입력으로 인한 경품 미수령은 다방이 책임지지 않습니다.</p>
            </div>
          </InputWrap>

          <InputWrap>
            <p className="title">이름</p>
            <div className="text-field">
              <input type="text" name="name" value={state.name} onChange={changeState} />
              <p className="black">경품을 수령하실 분의 이름을 입력해 주세요.</p>
              <p className="red">*회원정보 상의 이름과 동일해야하며, 잘못된 정보 입력으로 인한 경품 미수령은 다방이 책임지지 않습니다.</p>
            </div>
          </InputWrap>

          <InputWrap>
            <p className="title">연락처</p>
            <div className="text-field">
              <input type="text" name="phone" value={state.phone} onChange={changeState} />
              <p className="black">이벤트 당첨시 연락 받으실 연락처를 입력해주세요.</p>
              <p className="red">*잘못된 정보 입력으로 인한 경품 미수령은 다방이 책임지지 않습니다.</p>
            </div>
          </InputWrap>
        </Box>

        <BtnWrap>
          <Button onClick={submit}>
            <p className="bold">이벤트 참여</p>
            <p className="normal">작성 정보 제출하기</p>
          </Button>
        </BtnWrap>
      </FormWrap>
    </Wrap>
  );
}

export default ProFormComponent;
